import { captureFirstTouchAttribution } from "@omnicanvas/analytics";
import { useEffect } from "react";

/**
 * Keeps the acquisition hook explicit at the router boundary while sharing
 * the actual cookie implementation with app.omnicanvasnotes.com.
 */
export function captureSignupAttribution(): void {
  captureFirstTouchAttribution();
}

export function useSignupAttribution(): void {
  useEffect(() => {
    captureSignupAttribution();
  }, []);
}
